;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'
import { identifyPage } from 'src/deprecated/utils/report/tracking'

export function useAppAnalytics(): void {
  const { events, pathname, query } = useRouter()

  const hasIdentifiedFirstPageRef = useRef(false)

  const queryRef = useRef(query)
  // oxlint-disable-next-line react-hooks/refs -- TODO: fix this genuine linter error if you are working on this code.
  queryRef.current = query

  // identify initial page
  useEffect(() => {
    if (hasIdentifiedFirstPageRef.current) return
    identifyPage(pathname, queryRef.current)
    hasIdentifiedFirstPageRef.current = true
  }, [pathname])

  useEffect(() => {
    const handleRouteChange = () => {
      identifyPage(pathname, queryRef.current)
    }

    events.on('routeChangeComplete', handleRouteChange)

    return () => events.off('routeChangeComplete', handleRouteChange)
  }, [events, pathname])
}
